import React from 'react';
import { string } from 'prop-types';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { LoyaltyWelcomeCard as LoyaltyBenefitsComponent } from '@thd-olt-component-react/loyalty-benefits';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';

export function LoyaltyBenefits({ id }) {

  return (
    <ErrorBoundary name="loyalty-benefits">
      <QueryProvider cacheKey="loyalty-benefits-cacheKey">
        <LoyaltyBenefitsComponent componentId={id} />
      </QueryProvider>
    </ErrorBoundary>
  );
}

LoyaltyBenefits.propTypes = {
  id: string,
};

LoyaltyBenefits.defaultProps = {
  id: undefined,
};
